export default __webpack_public_path__ + "static/media/thumbnail-04.c8df5e61.png";